<app-signup-form>
    <app-additional-details slideNumber="1"></app-additional-details>
    <app-emergency-contacts slideNumber="2"></app-emergency-contacts>
    <app-next-of-kin slideNumber="2"></app-next-of-kin>
    <app-payment-method slideNumber="3"></app-payment-method>
    <app-first-payment slideNumber="4" [firstPaymentContent]="firstPaymentContent">
    </app-first-payment>
</app-signup-form>

<style>
    :host ::ng-deep .signupSubmitSpinner::ng-deep {
        position: absolute;
        left: 86px;
        bottom: 6px;
    }
</style>

<!-- pay-securely-button-text="@Model.Content.PaySecurelyButtonText"
        continue-payment-button-text="@Model.Content.ContinuePaymentButtonText"
        enter-amount-heading="@Model.Content.EnterAmountHeading"
        enter-amount-sub-heading="@Model.Content.EnterAmountSubHeading"
        enter-amount-body="@Model.Content.EnterAmountBody" card-details-heading="@Model.Content.CardDetailsHeading"
        card-details-sub-heading="@Model.Content.CardDetailsSubHeading"
        card-details-body="@Model.Content.CardDetailsBody" failed-payment-message="@Model.Content.FailedPaymentMessage"
        error-payment-message="@Model.Content.ErrorPaymentMessage" thank-you-page-url="@Model.Content.ThankYouPage"
        payment-card-page-url="/sign-up/worldpay/" processing-payment-title="@Model.Content.ProcessingPaymentTitle"
        processing-payment-body="@Model.Content.ProcessingPaymentBody" slide-id="firstPayment" -->